export default {
  sm: `
  미래 자산이 저장된 데이터센터는
  가치 창출의 원천입니다.
  `
};
